import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Modal from '../../../client/components/Modal';

const SELECTOR_WRAPPER = '.p-court-booking-confirmation';
const SELECTOR_MODAL = '#js-court-booking-confirmation-modal';
const SELECTOR_CANCEL_BUTTON = '.p-court-booking-confirmation__cancel-booking-btn';
const SELECTOR_MODAL_CANCEL_BUTTON = '.p-court-booking-confirmation__modal-cancel-btn';
const SELECTOR_MODAL_ACTION_BUTTON = '.p-court-booking-confirmation__modal-action-btn';

const SELECTOR_SNACKBAR = '.lta-snackbar';
const SELECTOR_ALERT = '.js-alert-dismiss';

const CLICK_EVENT = 'click';

class CourtBookingConfirmation {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.confirmationModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.confirmationModal = new Modal(this.confirmationModalElement, { backdrop: 'static' });
		this.cancelBookingButton = SelectorEngine.findOne(SELECTOR_CANCEL_BUTTON, this._wrapper);

		this.modalCancelButton = SelectorEngine.findOne(SELECTOR_MODAL_CANCEL_BUTTON, this.confirmationModalElement);
		this.modalActionButton = SelectorEngine.findOne(SELECTOR_MODAL_ACTION_BUTTON, this.confirmationModalElement);

		this.alertWrapper = SelectorEngine.findOne(SELECTOR_SNACKBAR, this._wrapper);
		if(this.alertWrapper) {
			this.dismissAlert = SelectorEngine.findOne(SELECTOR_ALERT, this.alertWrapper);
			EventHandler.on(this.dismissAlert, CLICK_EVENT, this.dismissAlertClickHandler.bind(this));
		}

		EventHandler.on(this.cancelBookingButton, CLICK_EVENT, this.cancelButtonClickHandler.bind(this));
		EventHandler.on(this.modalCancelButton, CLICK_EVENT, () => {
			this.confirmationModal.hide();
		});
	}

	dismissAlertClickHandler() {
		this.alertWrapper.parentElement.classList.add('u-hidden');
	}

	cancelButtonClickHandler() {
		this.confirmationModal.show();
	}
}

const globalCourtBookingConfirmation = new CourtBookingConfirmation();
export default globalCourtBookingConfirmation;
